import { FC } from 'react';
import { teams } from '../../constants/teams';
import styles from './TeamSelector.module.css';

interface TeamSelectorProps {
  value: number;
  onTeamSelected: (teamId: number) => void;
}

export const TeamSelector: FC<TeamSelectorProps> = ({ value, onTeamSelected }) => {

  return (
    <div className={styles.container}>
      <select
        value={value}
        onChange={(e) => onTeamSelected(Number(e.target.value))}
      >
        {teams.map((team) => (
          <option key={team.id} value={team.id}>
            {team.name}
          </option>
        ))}
      </select>
    </div>
  );
}
